import { ApplicationStatus } from '@/queries/family_applications/requests.ts'
import { createContext, useContext, useState, ReactNode } from 'react'

type ApplicantData = {
  name: string | ReactNode
  status?: ApplicationStatus
  hideStatus?: boolean
}

interface ApplicationProps {
  headerData: ApplicantData | null
  setHeaderData: (data: ApplicantData | null) => void
  refreshApplication: boolean
  setRefreshApplication: (refresh: boolean) => void
}

const ApplicationContext = createContext<ApplicationProps | undefined>(
  undefined
)

export const ApplicationProvider = ({ children }: { children: ReactNode }) => {
  const [headerData, setHeaderData] = useState<ApplicantData | null>(null)
  const [refreshApplication, setRefreshApplication] = useState<boolean>(false)
  return (
    <ApplicationContext.Provider
      value={{
        headerData,
        setHeaderData,
        refreshApplication,
        setRefreshApplication,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  )
}

// eslint-disable-next-line
export const useApplication = () => {
  const context = useContext(ApplicationContext)
  if (!context) {
    throw new Error('useApplication must be used within an ApplicationProvider')
  }
  return context
}
